function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-8);}.cls-2{fill:url(#linear-gradient-7);}.cls-3{fill:url(#linear-gradient-5);}.cls-4{fill:url(#linear-gradient-6);}.cls-5{fill:url(#linear-gradient-9);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient);}.cls-10{fill:#fff;}.cls-11{fill:url(#linear-gradient-43);}.cls-12{fill:url(#linear-gradient-40);}.cls-13{fill:url(#linear-gradient-41);}.cls-14{fill:url(#linear-gradient-42);}.cls-15{fill:url(#linear-gradient-49);}.cls-16{fill:url(#linear-gradient-48);}.cls-17{fill:url(#linear-gradient-45);}.cls-18{fill:url(#linear-gradient-47);}.cls-19{fill:url(#linear-gradient-44);}.cls-20{fill:url(#linear-gradient-46);}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:url(#linear-gradient-19);}.cls-26{fill:url(#linear-gradient-14);}.cls-27{fill:url(#linear-gradient-21);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:url(#linear-gradient-28);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-32);}.cls-34{fill:url(#linear-gradient-31);}.cls-35{fill:url(#linear-gradient-33);}.cls-36{fill:url(#linear-gradient-30);}.cls-37{fill:url(#linear-gradient-15);}.cls-38{fill:url(#linear-gradient-16);}.cls-39{fill:url(#linear-gradient-17);}.cls-40{fill:url(#linear-gradient-18);}.cls-41{fill:url(#linear-gradient-35);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-36);}.cls-44{fill:url(#linear-gradient-38);}.cls-45{fill:url(#linear-gradient-27);}.cls-46{fill:url(#linear-gradient-24);}.cls-47{fill:url(#linear-gradient-26);}.cls-48{fill:url(#linear-gradient-29);}.cls-49{fill:url(#linear-gradient-37);}.cls-50{fill:url(#linear-gradient-39);}.cls-51{fill:url(#linear-gradient-57);}.cls-52{fill:url(#linear-gradient-58);}.cls-53{fill:url(#linear-gradient-59);}.cls-54{fill:url(#linear-gradient-53);}.cls-55{fill:url(#linear-gradient-54);}.cls-56{fill:url(#linear-gradient-55);}.cls-57{fill:url(#linear-gradient-56);}.cls-58{fill:url(#linear-gradient-50);}.cls-59{fill:url(#linear-gradient-51);}.cls-60{fill:url(#linear-gradient-52);}.cls-61{fill:url(#linear-gradient-63);}.cls-62{fill:url(#linear-gradient-64);}.cls-63{fill:url(#linear-gradient-60);}.cls-64{fill:url(#linear-gradient-61);}.cls-65{fill:url(#linear-gradient-62);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 23.57,
  y1: 151.69,
  x2: 242.42,
  y2: 151.69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#354094"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9249ad"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 23.57,
  y1: 172.56,
  x2: 242.42,
  y2: 172.56,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 23.57,
  y1: 191.48,
  x2: 242.42,
  y2: 191.48,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 23.57,
  y1: 207.62,
  x2: 242.42,
  y2: 207.62,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 23.57,
  y1: 220.25,
  x2: 242.42,
  y2: 220.25,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 23.57,
  y1: 228.79,
  x2: 242.42,
  y2: 228.79,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 23.57,
  y1: 232.82,
  x2: 242.42,
  y2: 232.82,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 23.57,
  y1: 232.22,
  x2: 242.42,
  y2: 232.22,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 23.57,
  y1: 226.99,
  x2: 242.42,
  y2: 226.99,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 23.57,
  y1: 217.34,
  x2: 242.42,
  y2: 217.34,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 23.57,
  y1: 203.72,
  x2: 242.42,
  y2: 203.72,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 23.57,
  y1: 186.79,
  x2: 242.42,
  y2: 186.79,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 23.57,
  y1: 167.27,
  x2: 242.42,
  y2: 167.27,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 23.57,
  y1: 146.06,
  x2: 242.42,
  y2: 146.06,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 23.57,
  y1: 124.1,
  x2: 242.42,
  y2: 124.1,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-16",
  x1: 23.57,
  y1: 102.4,
  x2: 242.42,
  y2: 102.4,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-17",
  x1: 23.57,
  y1: 81.95,
  x2: 242.42,
  y2: 81.95,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-18",
  x1: 23.57,
  y1: 63.68,
  x2: 242.42,
  y2: 63.68,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-19",
  x1: 23.57,
  y1: 48.39,
  x2: 242.42,
  y2: 48.39,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-20",
  x1: 23.57,
  y1: 36.77,
  x2: 242.42,
  y2: 36.77,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-21",
  x1: 23.57,
  y1: 29.37,
  x2: 242.42,
  y2: 29.37,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-22",
  x1: 23.57,
  y1: 26.55,
  x2: 242.42,
  y2: 26.55,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-23",
  x1: 23.57,
  y1: 28.36,
  x2: 242.42,
  y2: 28.36,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-24",
  x1: 23.57,
  y1: 34.77,
  x2: 242.42,
  y2: 34.77,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-25",
  x1: 23.57,
  y1: 45.5,
  x2: 242.42,
  y2: 45.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-26",
  x1: 23.57,
  y1: 60.05,
  x2: 242.42,
  y2: 60.05,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-27",
  x1: 23.57,
  y1: 77.73,
  x2: 242.42,
  y2: 77.73,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-28",
  x1: 23.57,
  y1: 97.78,
  x2: 242.42,
  y2: 97.78,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-29",
  x1: 23.57,
  y1: 119.29,
  x2: 242.42,
  y2: 119.29,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-30",
  x1: 2.4,
  y1: 151.74,
  x2: 263.6,
  y2: 151.74,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-31",
  x1: 2.4,
  y1: 172.97,
  x2: 263.6,
  y2: 172.97,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-32",
  x1: 2.4,
  y1: 192.84,
  x2: 263.6,
  y2: 192.84,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-33",
  x1: 2.4,
  y1: 210.74,
  x2: 263.6,
  y2: 210.74,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-34",
  x1: 2.4,
  y1: 226.13,
  x2: 263.6,
  y2: 226.13,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-35",
  x1: 2.4,
  y1: 238.52,
  x2: 263.6,
  y2: 238.52,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-36",
  x1: 2.4,
  y1: 247.52,
  x2: 263.6,
  y2: 247.52,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-37",
  x1: 2.4,
  y1: 252.82,
  x2: 263.6,
  y2: 252.82,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-38",
  x1: 2.4,
  y1: 254.29,
  x2: 263.6,
  y2: 254.29,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-39",
  x1: 2.4,
  y1: 251.91,
  x2: 263.6,
  y2: 251.91,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-40",
  x1: 2.4,
  y1: 245.7,
  x2: 263.6,
  y2: 245.7,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-41",
  x1: 2.4,
  y1: 235.86,
  x2: 263.6,
  y2: 235.86,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-42",
  x1: 2.4,
  y1: 222.71,
  x2: 263.6,
  y2: 222.71,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-43",
  x1: 2.4,
  y1: 206.68,
  x2: 263.6,
  y2: 206.68,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-44",
  x1: 2.4,
  y1: 188.26,
  x2: 263.6,
  y2: 188.26,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-45",
  x1: 2.4,
  y1: 168.01,
  x2: 263.6,
  y2: 168.01,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-46",
  x1: 2.4,
  y1: 146.55,
  x2: 263.6,
  y2: 146.55,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-47",
  x1: 2.4,
  y1: 124.58,
  x2: 263.6,
  y2: 124.58,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-48",
  x1: 2.4,
  y1: 102.77,
  x2: 263.6,
  y2: 102.77,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-49",
  x1: 2.4,
  y1: 81.81,
  x2: 263.6,
  y2: 81.81,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-50",
  x1: 2.4,
  y1: 62.35,
  x2: 263.6,
  y2: 62.35,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-51",
  x1: 2.4,
  y1: 45,
  x2: 263.6,
  y2: 45,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-52",
  x1: 2.4,
  y1: 30.29,
  x2: 263.6,
  y2: 30.29,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-53",
  x1: 2.4,
  y1: 18.67,
  x2: 263.6,
  y2: 18.67,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-54",
  x1: 2.4,
  y1: 10.53,
  x2: 263.6,
  y2: 10.53,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-55",
  x1: 2.4,
  y1: 6.13,
  x2: 263.6,
  y2: 6.13,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-56",
  x1: 2.4,
  y1: 5.59,
  x2: 263.6,
  y2: 5.59,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-57",
  x1: 2.4,
  y1: 8.89,
  x2: 263.6,
  y2: 8.89,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-58",
  x1: 2.4,
  y1: 15.98,
  x2: 263.6,
  y2: 15.98,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-59",
  x1: 2.4,
  y1: 26.65,
  x2: 263.6,
  y2: 26.65,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-60",
  x1: 2.4,
  y1: 40.53,
  x2: 263.6,
  y2: 40.53,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-61",
  x1: 2.4,
  y1: 57.18,
  x2: 263.6,
  y2: 57.18,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-62",
  x1: 2.4,
  y1: 76.09,
  x2: 263.6,
  y2: 76.09,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-63",
  x1: 2.4,
  y1: 96.69,
  x2: 263.6,
  y2: 96.69,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-64",
  x1: 2.4,
  y1: 118.33,
  x2: 263.6,
  y2: 118.33,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M48.57,156.89v-47.96l-.94-7.55h43.81c7.62,0,13.33,1.51,17.14,4.53,3.81,3.02,5.71,7.74,5.71,14.16v18.03c0,6.55-1.89,11.32-5.66,14.3-3.78,2.99-9.5,4.48-17.18,4.48h-42.86ZM66.98,143.86h21.62c4.85,0,7.3-2.23,7.36-6.7v-16.33c0-1.82-.54-3.38-1.6-4.67-1.07-1.29-2.99-1.94-5.76-1.94h-21.62v29.65Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M127.5,156.89v-55.52h18.13v55.52h-18.13Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M171.4,156.89c-4.28,0-7.43-.19-9.44-.57-2.02-.38-3.02-.82-3.02-1.32l5.66-12.18c1.45.25,4.44.49,8.97.71,4.53.22,10.42.33,17.66.33h7.46c2.2,0,3.68-.31,4.44-.94.76-.63,1.13-1.54,1.13-2.74v-.94c0-1.51-.38-2.55-1.13-3.12-.76-.57-2.24-.85-4.44-.85h-21.62c-6.36,0-10.98-1.18-13.88-3.54-2.9-2.36-4.34-6.22-4.34-11.57v-3.4c0-2.77.52-5.32,1.56-7.65,1.04-2.33,2.82-4.2,5.33-5.62,2.52-1.42,5.98-2.12,10.39-2.12h31.35c3.84,0,7.03.22,9.58.66,2.55.44,3.82.91,3.82,1.42l-2.83,11.71c-1.76-.19-5.08-.39-9.96-.61-4.88-.22-11.06-.33-18.55-.33l-6.8-.09c-1.95,0-3.34.27-4.15.8-.82.54-1.26,1.53-1.32,2.97v.66c0,1.45.44,2.45,1.32,3.02.88.57,2.3.85,4.25.85h20.77c4.03,0,7.46.41,10.29,1.23,2.83.82,5,2.31,6.51,4.48,1.51,2.17,2.27,5.37,2.27,9.58v3.4c0,4.72-1.21,8.53-3.64,11.42-2.42,2.9-6.63,4.34-12.6,4.34h-35.03Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M233.99,152.09c-.22,0-.4-.18-.4-.41s.18-.41.4-.41.41.18.41.41-.18.41-.41.41Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M227.09,174.12c-.86,0-1.56-.7-1.56-1.56s.7-1.56,1.56-1.56,1.56.7,1.56,1.56-.7,1.56-1.56,1.56Z"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 215.91,
  cy: 191.48,
  r: 2.88
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M200.98,211.17c-1.96,0-3.56-1.59-3.56-3.56s1.59-3.56,3.56-3.56,3.56,1.59,3.56,3.56-1.59,3.56-3.56,3.56Z"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 183,
  cy: 220.25,
  r: 3.71
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 162.75,
  cy: 228.79,
  r: 4
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M141.14,237.12c-2.37,0-4.3-1.92-4.3-4.3s1.92-4.3,4.3-4.3,4.3,1.92,4.3,4.3-1.92,4.3-4.3,4.3Z"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 119.16,
  cy: 232.22,
  r: 4.64
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M97.81,231.98c-2.76,0-4.99-2.24-4.99-4.99s2.24-4.99,4.99-4.99,4.99,2.24,4.99,4.99-2.24,4.99-4.99,4.99Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M78.06,222.65c-2.93,0-5.31-2.38-5.31-5.31s2.38-5.31,5.31-5.31,5.31,2.38,5.31,5.31-2.38,5.31-5.31,5.31Z"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-22",
  cx: 60.8,
  cy: 203.72,
  r: 5.59
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-23",
  cx: 46.8,
  cy: 186.79,
  r: 5.86
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M36.68,173.28c-3.32,0-6.01-2.69-6.01-6.01s2.69-6.01,6.01-6.01,6.01,2.69,6.01,6.01-2.69,6.01-6.01,6.01Z"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-26",
  cx: 30.96,
  cy: 146.06,
  r: 6.08
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-37",
  cx: 29.85,
  cy: 124.1,
  r: 6.1
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-38",
  d: "M33.37,108.46c-3.34,0-6.06-2.71-6.06-6.06s2.71-6.06,6.06-6.06,6.06,2.71,6.06,6.06-2.71,6.06-6.06,6.06Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-39",
  d: "M41.43,87.88c-3.27,0-5.93-2.65-5.93-5.93s2.65-5.93,5.93-5.93,5.93,2.65,5.93,5.93-2.65,5.93-5.93,5.93Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-40",
  d: "M53.64,69.4c-3.16,0-5.73-2.56-5.73-5.73s2.56-5.73,5.73-5.73,5.73,2.56,5.73,5.73-2.56,5.73-5.73,5.73Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M69.43,53.84c-3.01,0-5.45-2.44-5.45-5.45s2.44-5.45,5.45-5.45,5.45,2.44,5.45,5.45-2.44,5.45-5.45,5.45Z"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-28",
  cx: 88.09,
  cy: 36.77,
  r: 5.17
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M108.79,34.2c-2.66,0-4.82-2.16-4.82-4.82s2.16-4.82,4.82-4.82,4.82,2.16,4.82,4.82-2.16,4.82-4.82,4.82Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M130.59,31.02c-2.47,0-4.47-2-4.47-4.47s2-4.47,4.47-4.47,4.47,2,4.47,4.47-2,4.47-4.47,4.47Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M152.49,32.51c-2.3,0-4.16-1.86-4.16-4.16s1.86-4.16,4.16-4.16,4.16,1.86,4.16,4.16-1.86,4.16-4.16,4.16Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-46",
  d: "M173.52,38.63c-2.13,0-3.86-1.73-3.86-3.86s1.73-3.86,3.86-3.86,3.86,1.73,3.86,3.86-1.73,3.86-3.86,3.86Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M192.7,49.07c-1.97,0-3.57-1.6-3.57-3.57s1.6-3.57,3.57-3.57,3.57,1.6,3.57,3.57-1.6,3.57-3.57,3.57Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "cls-47",
  d: "M209.18,63.36c-1.83,0-3.31-1.48-3.31-3.31s1.48-3.31,3.31-3.31,3.31,1.48,3.31,3.31-1.48,3.31-3.31,3.31Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "cls-45",
  d: "M222.23,79.89c-1.19,0-2.16-.97-2.16-2.16s.97-2.16,2.16-2.16,2.16.97,2.16,2.16-.97,2.16-2.16,2.16Z"
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-31",
  cx: 231.24,
  cy: 97.78,
  r: 0.86
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "cls-48",
  d: "M235.78,119.38s-.09-.04-.09-.09.04-.09.09-.09.09.04.09.09-.04.09-.09.09Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-36",
  d: "M255.56,152.03c-.16,0-.29-.13-.29-.29s.13-.29.29-.29.29.13.29.29-.13.29-.29.29Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-34",
  d: "M249.81,174.08c-.62,0-1.12-.5-1.12-1.12s.5-1.12,1.12-1.12,1.12.5,1.12,1.12-.5,1.12-1.12,1.12Z"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-33",
  cx: 240.38,
  cy: 192.84,
  r: 2.23
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "cls-35",
  d: "M227.61,213.95c-1.77,0-3.21-1.44-3.21-3.21s1.44-3.21,3.21-3.21,3.21,1.44,3.21,3.21-1.44,3.21-3.21,3.21Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "cls-42",
  d: "M211.89,229.64c-1.94,0-3.51-1.57-3.51-3.51s1.57-3.51,3.51-3.51,3.51,1.57,3.51,3.51-1.57,3.51-3.51,3.51Z"
});

var _ref40 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-41",
  cx: 193.73,
  cy: 238.52,
  r: 3.7
});

var _ref41 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-43",
  cx: 173.66,
  cy: 247.52,
  r: 3.95
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "cls-49",
  d: "M152.33,257.01c-2.31,0-4.19-1.88-4.19-4.19s1.88-4.19,4.19-4.19,4.19,1.88,4.19,4.19-1.88,4.19-4.19,4.19Z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "cls-44",
  d: "M130.38,258.74c-2.46,0-4.45-1.99-4.45-4.45s1.99-4.45,4.45-4.45,4.45,1.99,4.45,4.45-1.99,4.45-4.45,4.45Z"
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-50",
  cx: 108.51,
  cy: 251.91,
  r: 4.75
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M87.41,250.74c-2.78,0-5.04-2.26-5.04-5.04s2.26-5.04,5.04-5.04,5.04,2.26,5.04,5.04-2.26,5.04-5.04,5.04Z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M67.75,241.16c-2.93,0-5.3-2.37-5.3-5.3s2.37-5.3,5.3-5.3,5.3,2.37,5.3,5.3-2.37,5.3-5.3,5.3Z"
});

var _ref47 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-14",
  cx: 50.12,
  cy: 222.71,
  r: 5.53
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M35.06,212.44c-3.18,0-5.76-2.58-5.76-5.76s2.58-5.76,5.76-5.76,5.76,2.58,5.76,5.76-2.58,5.76-5.76,5.76Z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M23.05,194.18c-3.27,0-5.92-2.65-5.92-5.92s2.65-5.92,5.92-5.92,5.92,2.65,5.92,5.92-2.65,5.92-5.92,5.92Z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M14.48,174.05c-3.34,0-6.05-2.71-6.05-6.05s2.71-6.05,6.05-6.05,6.05,2.71,6.05,6.05-2.71,6.05-6.05,6.05Z"
});

var _ref51 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-20",
  cx: 9.63,
  cy: 146.55,
  r: 6.09
});

var _ref52 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-18",
  cx: 8.62,
  cy: 124.58,
  r: 6.11
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M11.46,108.84c-3.35,0-6.07-2.72-6.07-6.07s2.72-6.07,6.07-6.07,6.07,2.72,6.07,6.07-2.72,6.07-6.07,6.07Z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M18.11,87.8c-3.31,0-5.99-2.68-5.99-5.99s2.68-5.99,5.99-5.99,5.99,2.68,5.99,5.99-2.68,5.99-5.99,5.99Z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "cls-58",
  d: "M28.37,68.22c-3.24,0-5.87-2.63-5.87-5.87s2.63-5.87,5.87-5.87,5.87,2.63,5.87,5.87-2.63,5.87-5.87,5.87Z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "cls-59",
  d: "M41.89,50.66c-3.12,0-5.65-2.53-5.65-5.65s2.53-5.65,5.65-5.65,5.65,2.53,5.65,5.65-2.53,5.65-5.65,5.65Z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "cls-60",
  d: "M58.23,35.72c-3,0-5.43-2.43-5.43-5.43s2.43-5.43,5.43-5.43,5.43,2.43,5.43,5.43-2.43,5.43-5.43,5.43Z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "cls-54",
  d: "M76.9,23.87c-2.87,0-5.2-2.33-5.2-5.2s2.33-5.2,5.2-5.2,5.2,2.33,5.2,5.2-2.33,5.2-5.2,5.2Z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "cls-55",
  d: "M97.33,15.44c-2.71,0-4.91-2.2-4.91-4.91s2.2-4.91,4.91-4.91,4.91,2.2,4.91,4.91-2.2,4.91-4.91,4.91Z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "cls-56",
  d: "M118.88,10.76c-2.55,0-4.62-2.07-4.62-4.62s2.07-4.62,4.62-4.62,4.62,2.07,4.62,4.62-2.07,4.62-4.62,4.62Z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "cls-57",
  d: "M140.87,9.92c-2.39,0-4.33-1.94-4.33-4.33s1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33-1.94,4.33-4.33,4.33Z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "cls-51",
  d: "M162.62,12.97c-2.26,0-4.09-1.83-4.09-4.09s1.83-4.09,4.09-4.09,4.09,1.83,4.09,4.09-1.83,4.09-4.09,4.09Z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "cls-52",
  d: "M183.44,19.83c-2.12,0-3.84-1.72-3.84-3.84s1.72-3.84,3.84-3.84,3.84,1.72,3.84,3.84-1.72,3.84-3.84,3.84Z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "cls-53",
  d: "M202.67,30.25c-1.99,0-3.6-1.61-3.6-3.6s1.61-3.6,3.6-3.6,3.6,1.61,3.6,3.6-1.61,3.6-3.6,3.6Z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "cls-63",
  d: "M219.73,44.08c-1.96,0-3.55-1.59-3.55-3.55s1.59-3.55,3.55-3.55,3.55,1.59,3.55,3.55-1.59,3.55-3.55,3.55Z"
});

var _ref66 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-64",
  cx: 234.1,
  cy: 57.18,
  r: 2.72
});

var _ref67 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-65",
  cx: 245.32,
  cy: 76.09,
  r: 1.64
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "cls-61",
  d: "M253.02,97.32c-.35,0-.64-.29-.64-.64s.29-.64.64-.64.64.29.64.64-.29.64-.64.64Z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "cls-62",
  d: "M256.96,118.41s-.08-.04-.08-.08.04-.08.08-.08.08.04.08.08-.04.08-.08.08Z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    viewBox: "0 0 260 260",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.ae2c303b.svg";
export { ForwardRef as ReactComponent };